import {Init} from '@/core/Init'

class ExportSvg {

	private _defs: {} = {};

	private _bbox: DOMRect;

	constructor() {

	}


	extract(svg: Element): string {

		let str = '';
		let str_text: string = '';
		let str_attr: string = this.parseSvg(svg);

		let type: string = svg.nodeName;


		if (str_attr != '') {

			str += '<' + type + str_attr + '>';

			if (type == 'tspan') {

				str += svg.textContent;

			}

			if (svg.hasChildNodes()) {

				let child1: HTMLCollection = svg.children;

				if (child1) {

					for (let node1 of child1) {

						str += this.extract(node1);

					}
				}
			}
		}

		if (str_attr != '') {
			str += '</' + type + '>' + '\n';
		}

		return str;
	}


	/**
	 *
	 * @param node
	 */
	parseSvg(node: Element): string {

		// attributes we DO want to use
		let allow_attributes: string[] = ['id', 'transform', 'x', 'y', 'x1', 'x2', 'y1', 'y2', 'd', 'cx', 'cy', 'r', 'rx', 'ry', 'dy',
			'width', 'height', 'points', 'stroke', 'offset', 'font-size', 'text-anchor',
			'gradientTransform', 'gradientUnits'];

		// css classes we DO NOT want to parse as they are not visual
		let ignore_class: string[] = ['clickclip', 'xbox', 'ybox', 'sbox', 'tbox'];

		let str_attr: string = '';

		let type: string = node.nodeName;
		//console.log(type, node1.nodeType);
		if (node.nodeType != 1) {
			return str_attr;
		}

		let attrs: NamedNodeMap = node.attributes;

		//console.log(type, node.nodeType);
		if (attrs.length == 0 || type == 'defs') {

			return str_attr;

		} else if (window.getComputedStyle(node).getPropertyValue('display') == 'none') {

			return str_attr;

		} else if (node.hasAttribute('class')) {

			let classes: string[] = node.getAttribute('class').split(' ');

			for (let clss of classes) {
				// don't need to parse elements that are non-visual
				if (ignore_class.indexOf(clss) != -1) {
					return str_attr;
				}
			}
		}


		for (let attr of attrs) {

			if (allow_attributes.indexOf(attr.name) != -1) {

				if (attr.name == 'transform'
					&& node.hasAttribute('id')
					&& node.getAttribute('id').substring(0, 3) == 'com'
				) {

					let nodeG: SVGGraphicsElement = node as SVGGraphicsElement;
					let ctm: DOMMatrix = nodeG.getScreenCTM();

					str_attr += ' transform="matrix(' + ctm.a + ', ' + ctm.b + ', ' + ctm.c + ', ' + ctm.d + ', ' + (ctm.e -= this._bbox.x) + ', ' + (ctm.f -= (this._bbox.y+50)) + ')"';

				} else {

					str_attr += ' ' + attr.name + '="' + attr.value + '"';

				}
			}

			if (type == 'use' && attr.name == 'href') {

				let id: string = attr.value.substring(1);

				str_attr += ' ' + attr.name + '="' + attr.value + '"';

				if (this._defs[id] == undefined) {

					//console.log(id, this._defs, this._defs[id]);
					this.extractDef(id);

				}

			} else if (type != 'g' && attr.name == 'fill') {

				let id: string = attr.value.substring(5, attr.value.length - 6);

				str_attr += ' ' + attr.name + '="' + attr.value + '"';

				if (!this._defs[id]) {

					this.extractDef(id);

				}

			} else if (attr.name == 'font-family') {
				str_attr += ' font-family="sans-serif"';
			}
		}

		str_attr += this.extractStyle(node);

		return str_attr;

	}


	/**
	 *
	 * @param id
	 */
	extractDef(id: string): void {

		let use: Element = document.getElementById(id);

		if (use) {
			//console.log(id, use);
			let str: string = this.extract(use);
			this._defs[id] = str;
		}
	}


	/**
	 *
	 * @param node
	 */
	extractStyle(node: Element): string {

		let str: string = '';

		let styles: string[] = ['stroke-width', 'stop-color', 'shape-rendering', 'vector-effect', 'stroke-linecap'];

		let defs: CSSStyleDeclaration = window.getComputedStyle(node);

		if (defs.length > 0) {

			let style: string = ' style="';

			for (let def of defs) {

				if (styles.indexOf(def) != -1) {

					style += def + ':' + defs[def] + ';';

				} else if (def == 'fill' || def == 'stroke') {

					if (defs[def].substring(0, 3) == 'url') {

						//console.log(defs[def], defs[def].substring(6, defs[def].length - 8));

						let url: string = defs[def].substring(6, defs[def].length - 8);

						style += ' ' + def + ':url(#' + url + ');';

						if (!this._defs[url]) {

							this.extractDef(url);

						}
					} else {

						style += def + ':' + defs[def] + ';';

					}
				}
			}
			style += '"';
			str += style;

		}
		return str;
	}


	export(svgId: string) {

		let e: SVGGraphicsElement = (<SVGGraphicsElement><any>document.getElementById('svg-stage'));
		this._bbox = e.getBBox();

		//console.log(this._bbox);

		let elem: Element = document.getElementById(svgId);

		let svg_str: string = '';


		if (elem.hasChildNodes()) {

			let childs: HTMLCollection = elem.children;

			if (childs) {

				for (let node of childs) {

					svg_str += this.extract(node);

				}
			}
		}

		let str: string = '<svg xmlns="http://www.w3.org/2000/svg">' + '\n';

		str += svg_str;

		str += '<defs>' + '\n';

		for (let def in this._defs) {

			str += this._defs[def] + '\n';
		}

		str += '</defs>' + '\n';

		str += '</svg>';

		let svg = new Blob([str], {type: 'data/svg+xml;charset=utf-8'});

		let url = URL.createObjectURL(svg);

		let link = document.createElement('a');
		$('#tool-btns').append(link);

		link.setAttribute('target', '_blank');

		link.href = url;
		let name: string = (Init.design_name == '') ? 'cedarworks_design' : Init.design_name;
		link.download = name + '.svg';
		link.click();

		window.URL.revokeObjectURL(url);

	}


}

export {ExportSvg};

